<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-9"><a id="_idTextAnchor009"></a>Anointing</h2>
<p class="Verse-long-new">Aching heart and weary limbs</p>
<p class="Verse-long">crave anointing with the salve of love</p>
<p class="Verse-long">deep mind open to the well of fire</p>
<p class="Verse-long-new">Harrowed, broken, old pains recalled </p>
<p class="Verse-long">stuff no man should ever need to hear</p>
<p class="Verse-long">deep wounds slashed on who we are</p>
<p class="Verse-long-new">Soothed by love’s gentle balm, washed </p>
<p class="Verse-long">by Christ’s new love, bloody and alive,</p>
<p class="Verse-long">touched and healed, heartbeat strong.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-11.vue?2174e078